import { HttpClient, HttpHeaders } from "@angular/common/http"
import { BehaviorSubject, Observable, Subject, Subscription } from "rxjs"
import { ErrorService } from "src/app/error/err.service";
import { ToastService } from "../custom-overlay/toast/toast.service";
import { ToastType } from "../shared.enums";

export class RESTPROMISE {

    private isProgress_:BehaviorSubject<boolean> = new BehaviorSubject(false)
    isProgress$ = this.isProgress_.asObservable()
    private emitData :Promise<any>;
    private subscription :Subscription = Subscription.EMPTY;

    constructor(
        private requestmethod:Function,
        public http:HttpClient,
        private userloggedout:Observable<boolean>,
        private errorservice :ErrorService,
        private url:string,
        private moduleName:string,
        private toastService: ToastService
    ){
        this.userloggedout.subscribe((val:any)=>{
            this.cancelRequest()
        });
    }

    toStringify(postData:any){
        return JSON.stringify(postData)
    }

    headers = new HttpHeaders({'content-type': 'application/json'});

    postrequest(requestobj:any){
//console.log(this.isProgress_.getValue(),"post edit")
        if(!this.isProgress_.getValue()){
            this.isProgress_.next(true);
//console.log("Before EmitData",this.requestmethod,requestobj,typeof(requestobj))
            this.emitData = new Promise((resolve,reject)=>{
//console.log("After EmitData",this.requestmethod,requestobj,typeof(requestobj))

                this.subscription = this.requestmethod(this.toStringify(requestobj)).subscribe((dat:any)=>{
//console.log(dat,"DAT")
                    if(dat.isError){
                        this.handleError();
                        this.showError(this.errorservice.errmsg.browerr_msg,ToastType.failure);
                        this.errorservice.postOnlineErrors(this.createErrorObject(dat,1,1),1);
                        reject(dat)
                    }else{
                        resolve(dat)
                        this.isProgress_.next(false)
                    }
                },(err:any)=>{
                    reject(err);
                    this.isProgress_.next(false)
                })
            });
        }        
        return this.emitData
    }

    handleError(){
        this.isProgress_.next(false);
    }

    showError(errormsg:string,type:string){
        this.toastService.ShowToaster(this.moduleName +" :"+errormsg,type);
    }

    createErrorObject(val:any,errorState:number,customstate:number){
        const errobj = this.errorservice.httpobjectBuilder(errorState,customstate,val)
        errobj.url = this.url;
        return errobj;
    }


    cancelRequest(){
        if(this.isProgress_.getValue()){
            this.subscription.unsubscribe()
            this.stopRequest();
        }
    }

    stopRequest(){
        this.isProgress_.next(false);
    }
}